<template>
  <div id="app">
    <app-header></app-header>
    <div
      v-if="isSignedIn"
      class="d-flex flex-row mt-5">
      <admin-sidebar
        v-if="isAdmin"
        class="px-2 pt-4">
      </admin-sidebar>
      <app-sidebar
        v-else
        class="px-2 pt-4">
      </app-sidebar>
      <main>
        <b-container
          fluid
          class="bg-light">
          <b-row class="content">
            <b-col
              class="px-4 py-5">
              <router-view></router-view>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="px-0">
              <terms-footer></terms-footer>
            </b-col>
          </b-row>
        </b-container>
      </main>
    </div>

    <b-container
      v-if="!isSignedIn"
      fluid
      class="mt-5">
      <b-row class="content">
        <b-col
          class="py-5 mx-auto"
          md="6"
          lg="5">
          <router-view></router-view>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="px-0">
          <terms-footer></terms-footer>
        </b-col>
      </b-row>
    </b-container>

<!--    <cookie-popup></cookie-popup>-->
  </div>
</template>
<script>
  import AdminSidebar from '@/components/admin/AdminSidebar'
  import AppHeader from '@/components/common/AppHeader'
  import AppSidebar from '@/components/common/AppSidebar'
  import CookiePopup from '@/components/common/CookiePopup'
  import TermsFooter from '@/components/common/TermsFooter'

  export default {
    components: {
      CookiePopup,
      AdminSidebar,
      AppHeader,
      AppSidebar,
      TermsFooter
    },
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      },
      userName () {
        return this.currentUser.firstName + ' ' + this.currentUser.lastName
      },
      isSignedIn () {
        if (Object.keys(this.currentUser).length > 0) {
          return true
        }
        return false
      },
      isAdmin () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesAdmin = currentUser.roles.filter(role => role.roleOfUser === 'ADMIN')
          if (rolesAdmin.length > 0) {
            return true
          }
        }
        return false
      }
    },
    created () {
      this.$store.dispatch('tryAutoLogin')
        .then(() => {
          this.$router.replace(this.$route.query.redirect)
        })
        .catch(() => {
        }) // Do nothing because we already handle this
    }
  }
</script>

<style>
  body {
    color: #455a64;
  }

  aside {
    width: 260px;
    min-height: 90vh;
  }

  main {
    width: calc(100% - 260px)
  }

  a.nav-link {
    color: #6c757d;
  }

  a.nav-link:hover {
    color: #1976d2;
  }

  a.nav-link.active {
    color: #1976d2;
  }

  .btn {
    -webkit-border-radius: 0px;
    -moz-border-radius: 0px;
    border-radius: 0px;
  }

  .btn-link {
    color: #6c757d;
    text-decoration: none;
  }

  .btn-link:hover {
    color: #21272d;
  }

  .content {
    min-height: 90vh;
  }

  .custom-file-label::after {
    content: "Durchsuchen";
  }

  .mini-toastr {
    position: fixed;
    left: 50%;
    right: inherit;
    transform: translateX(-50%);
  }

  .mini-toastr__notification {
    opacity: 1;
    border-radius: 0;
    box-shadow: #3c3b3b 0 0 0;
    width: 350px;
  }

  .mini-toastr__notification:hover {
    opacity: 1;
    box-shadow: #000 0 0 1px;
  }

  .mini-toastr-notification__title {
    margin-bottom: 1rem;
  }

  .mini-toastr-notification__message {
    padding: 0;
  }

  .navbar {
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.1);
  }

  .navbar-text {
    padding-left: .5rem;
  }

  .nav-link {
    padding: .5rem 0;
  }

  .nav-item-icon {
    width: 30px;
  }

  .infobox-icon {
    font-size: 3rem;
    color: #99abb4;
  }

  .page-link {
    border-radius: 0 !important;
  }

  .infobox-link:hover {
    text-decoration: none;
  }

  .v-autocomplete-input {
    display: block;
    width: 100%;
    padding: .75rem .75rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  }

  .v-autocomplete-list {
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    -ms-flex-direction: column;
    flex-direction: column;
    padding-left: 0;
    margin-top: -1px;
    margin-bottom: 0;
    z-index: 1000;
  }

  .v-autocomplete-list-item {
    position: relative;
    display: block;
    padding: .25rem .75rem;
    margin-bottom: -1px;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, .125);
  }

  .v-autocomplete-list-item:hover {
    cursor: pointer;
    background-color: lightgrey;
  }

  .v-autocomplete-list-item address {
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue